/**
 * Single Resource – Toolkit form + image modal
 */
import { initPostMediaModal } from './post-media-modal.js';

initPostMediaModal();

(function () {
  'use strict';

  /* ── Toolkit Request Form (reCAPTCHA v3) ─────────────────────── */
  var form = document.getElementById('resource-toolkit-form');
  if (!form) return;

  var siteKey = form.dataset.recaptchaSiteKey || '';
  var ajaxUrl = form.dataset.ajaxUrl || '/wp-admin/admin-ajax.php';

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = form.querySelector('.resource-form__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
    }

    // Refresh nonce, get reCAPTCHA v3 token, then POST
    refreshNonce(function () {
      if (siteKey && typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function () {
          grecaptcha.execute(siteKey, { action: 'resource_toolkit' }).then(function (token) {
            sendForm(token);
          });
        });
      } else {
        sendForm('');
      }
    });
  });

  // The page may be served from cache with an expired nonce, so fetch a fresh
  // one. On failure, fall back to the nonce already rendered in the page.
  function refreshNonce(done) {
    var field = form.querySelector('input[name="nmtc_toolkit_nonce_field"]');
    var data = new FormData();
    data.append('action', 'nmtc_toolkit_nonce');

    var xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxUrl, true);
    xhr.onload = function () {
      try {
        var resp = JSON.parse(xhr.responseText);
        if (field && resp.success && resp.data && resp.data.nonce) {
          field.value = resp.data.nonce;
        }
      } catch (err) {
        // Keep the rendered nonce
      }
      done();
    };
    xhr.onerror = done;
    xhr.send(data);
  }

  function sendForm(recaptchaToken) {
    var data = new FormData(form);
    data.append('action', 'nmtc_resource_toolkit_request');
    data.append('g-recaptcha-response', recaptchaToken);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxUrl, true);
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        try {
          var resp = JSON.parse(xhr.responseText);
          if (resp.success && resp.data && resp.data.html) {
            // Replace the form wrapper with the documents list
            var wrapper = document.getElementById('resource-toolkit-wrapper');
            if (wrapper) {
              wrapper.innerHTML = resp.data.html;
            }
          } else {
            showFormError(resp.data && resp.data.message ? resp.data.message : 'Something went wrong. Please try again.');
          }
        } catch (err) {
          showFormError('Something went wrong. Please try again.');
        }
      } else {
        showFormError('Server error. Please try again later.');
      }
    };
    xhr.onerror = function () {
      showFormError('Network error. Please check your connection.');
    };
    xhr.send(data);
  }

  function showFormError(message) {
    var errEl = form.querySelector('.resource-form__error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'resource-form__error';
      form.appendChild(errEl);
    }
    errEl.textContent = message;

    var submitBtn = form.querySelector('.resource-form__submit');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'GET TOOLKIT';
    }
  }
})();
